/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const handleGeneralError = (errPool: Record<string, any>, statusCode: number) => {
    for (const [key, value] of Object.entries(errPool)) {
        if (statusCode === value) {
            return key;
        }
    }
};
